module.exports = __webpack_public_path__ + "img/20240523_liyuzhe.7265cd35.jpeg";